module.exports = __webpack_public_path__ + "img/機械力学_講師画像_田浦先生.f6a83703.jpg";